import { render, staticRenderFns } from "./ReceiptEditAddCareV1.vue?vue&type=template&id=eba15a24&"
import script from "./ReceiptEditAddCareV1.vue?vue&type=script&lang=ts&"
export * from "./ReceiptEditAddCareV1.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptEditAddCareV1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
